import { IBaseWinPresentationState } from '@GFTypes/GameStoreTypes/BaseWinPresentationState';

export const BASE_WIN_PRESENTATION_STATE_DEFAULTS: IBaseWinPresentationState = {
    finalWinLevelName: '',
    finalWinLevelIndex: 0,
    odometerDurationsPerWinLevel: [],
    winningPositions: [],
    isStaticJackpotWon: false,
    currentWinPresentationStepIndex: 0,
    lastWinPresentationStepIndex: 0,
    isLastWinPresentationStep: false,
    winPresentationBeforeExpandingDuration: undefined
};
